<template>
	<div class="response">
		<div class="response__image">
			<router-link :to="{ name: 'view-user', params: { user_id: response.user.id } }">
				<img :src="`/images/avatar/${response.user.id}`" class="avatar avatar--small">
			</router-link>
			<span class="date">{{ response.createdAt }}</span>
		</div>
		<div class="response__content">
			<h3>{{ response.user.name }}</h3>
			<span>{{ response.user.member.name }}</span>
			<div v-html="response.content"></div>
			<ul class="response__documents" v-if="response.attachments">
				<li v-for="doc in response.attachments">
                    <AttachmentDownload :attachment="doc"></AttachmentDownload>
				</li>
			</ul>
		</div>
        <div class="response__actions" v-if="response.user.id === user.id">
            <ul class="actions">
                <li>
                    <button class="action" @click.prevent="editResponse">
                        <svg class="svg-icon">
                            <use xlink:href="#icon--edit"></use>
						</svg>
                    </button>
                </li>
                <li>
                    <button class="action" @click.prevent="showDeleteModal">
                        <svg class="svg-icon">
                            <use xlink:href="#icon--delete"></use>
						</svg>
                    </button>
                </li>
            </ul>
        </div>
	</div>
</template>

<script>
	import API from './../../api';
    import { mapState } from 'vuex';
	import SvgIcon from '../SvgIcon';
    import AttachmentDownload from '../AttachmentDownload';

	export default {
		name: 'Response',
		components: {
            AttachmentDownload,
            SvgIcon,
        },
        computed: {
	        ...mapState({
		        user: state => state.auth.user,
	        }),
        },
		props: ['response'],
		data() {
			return {}
		},
		methods: {
		    showDeleteModal(){
		        console.log('showDeleteModal');
				this.$modal.show('dialog', {
					title:'Are you sure?',
					text: 'Clicking DELETE will remove this response.',
					buttons: [
						{
							class: 'btn btn--danger',
							title: 'DELETE',
							handler: () => {
								API.deleteOpportunityResponse(this.response.opportunityId, this.response.id)
                                    .then(response => {
                                        this.$emit('response:deleted', this.response);
                                        this.$modal.hide('dialog');
                                    })
                                    .catch(error => {
                                        this.$modal.hide('dialog')

                                        if (error.response) {
                                            // The request was made and the server responded with a status code
                                            // that falls out of the range of 2xx
                                            this.$modal.show('dialog', {
                                                title: 'Error',
                                                text: `
                                                    <p>${error.response.data.error}</p>
                                                    <p>Please refresh the page and try again.</p>
                                                `,
                                            });
                                        }
                                    });
							}
						},
					]
				});
            },
            editResponse(){
                this.$emit('response:edit', this.response);
            }
		},
	}
</script>

<style lang="scss">
	@import '~@/theme/_variables.scss';
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';

	.response {
		margin: 1rem 0 3rem 0;
		display: flex;
        position: relative;

		&__image {
			max-width: 4rem;
			margin-right: 2rem;
			@include display-flex;
			@include flex-direction(column);
			@include align-items(center);

			.avatar {
				margin-right: 0;
			}

			.date {
				font-size: 1rem;
				color: $text;
				width: 100%;
				text-align: center;
				display: block;
				margin-top: 0.5rem;
			}
		}

		&__content {
			width: 100%;
		}

		&__images {
			list-style: none;
			padding: 0;

			li {
				display: inline-block;
				vertical-align: middle;
				width: 100%;
				max-width: 8rem;
				max-height: 8rem;

				img {
					display: block;
					margin: 0 auto;
					max-width: 100%;
				}
			}
		}

		&__documents {
			padding: 0;
			margin-top: 2rem;
			list-style: none;

            li + li {
                margin-top: 1rem;
            }

			li .svg-icon {
				width: 1.6rem;
				height: 1.6rem;
			}
		}

		h3 {
			display: inline-block;
			margin-bottom: 0;
			color: black;

			+ span {
				color: $text;
				margin-left: 10px;
				font-weight: normal;
			}
		}


		p {
			color: #657787;
			font-size: 14px;
			letter-spacing: 0.5px;
			line-height: 17px;
		}

        &__actions{
            position: absolute;
            right: 0;
            top: 0;
        }
	}

    .actions{
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            display: inline-block;
            vertical-align: middle;
        }

        .action{
            appearance: none;
            background-color: transparent;
            border: none;
            outline: none !important;
            cursor: pointer;

            .svg-icon{
                height: 1.6rem;
                width: 1.6rem;
                fill: #657787;
                stroke: transparent;
                margin-right: 0;
            }
        }
    }
</style>
